const eggshellWhite = "#F4F1DE";
const terraCottaPink = "#EAB69F";
const independencePurple = "#3D405B";
const greenSheen = "#81B29A";
const deepChampagneYellow = "#F2CC8F";
const roseTaupe = "#8F5D5D";
const battleshipGray = "#8C8C8C";
const navyBlue = "#6176d8";

export const palette = {
  cta: independencePurple,
  background: eggshellWhite,
  secondBackground: terraCottaPink,
  primary: roseTaupe,
  secondary: deepChampagneYellow,
  tertiary: greenSheen,
  // tertiary: navyBlue,
  disabled: battleshipGray,
  error: roseTaupe,
};
